import React from 'react'
import { HeroSection } from '../components/sections/HeroSection'
import { InnovationSection } from '../components/sections/InnovationSection'
import { TechShowcaseSection } from '../components/sections/TechShowcaseSection'
import { SolutionsShowcase } from '../components/sections/SolutionsShowcase'
import { SpecializedSolutions } from '../components/sections/SpecializedSolutions'
import { ComparisonSection } from '../components/sections/ComparisonSection'
import { PartnersSection } from '../components/sections/PartnersSection'

export const HomePage: React.FC = () => {
  return (
    <div className="min-h-screen">
      <HeroSection />
      <InnovationSection />
      <SolutionsShowcase />
      <TechShowcaseSection />
      <ComparisonSection />
      <PartnersSection />
      <SpecializedSolutions />
    </div>
  )
}